
$(function () {
	$('.topSlider__slideWrap').slick({
		autoplay: true,
		arrows: false,
		dots: true,
		infinite: true
	});

	$('.productSlider').slick({
		autoplay: true,
		arrows: false,
		dots: true,
		infinite: true
	});

	$('.introSampleSlider').slick({
		autoplay: true,
		arrows: true,
		dots: false,
		infinite: true,
		prevArrow: '<div class="introSampleSlider__arrowPrev"></div>',
		nextArrow: '<div class="introSampleSlider__arrowNext"></div>',
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 480,
			settings: {
				slidesToShow: 2,
				slidesToScroll: 1,
			}
		}]
	});

	$('.recruitSlider__slideWrap').slick({
		autoplay: true,
		arrows: false,
		dots: true,
		infinite: true
	});



	$('.topMenu__listItemLink').on('click', function () {
		const tu = $(this).next('.topInfoMenu').hasClass('toUp');
		const td = $(this).next('.topInfoMenu').hasClass('toDown');

		$('.topInfoMenu').removeClass('toUp toDown');
		if ($(window).scrollTop() + $(window).height() > $(this).offset().top + 330) {
			$(this).next('.topInfoMenu').addClass('toDown');
		} else {
			$(this).next('.topInfoMenu').addClass('toUp');
		}

		if (tu) {
			$(this).next('.topInfoMenu').removeClass('toUp');
			console.log('tu検出されました！');
		} else if (td) {
			$(this).next('.topInfoMenu').removeClass('toDown');
			console.log('td検出されました！');
		} else {
			console.log('nothing');
		}
	})

	// TOPに戻るボタン
	$('.contactLink__toTop').on('click', function () {

		$('body,html').animate({
			scrollTop: 0
		}, 300);
		return false;

	})

	$('.headerNavi__listItemLink--hasChild').on('click', function () {

		$(this).toggleClass('open');

	})


});



function obs1() {
	const obTarget = document.querySelector('.scTarget');
	const chgTarget = document.querySelector('.contactLink');

	const options = {
		root: null, //親要素
		rootMargin: '-100px',
		threshold: 0
	}

	const obs = new IntersectionObserver(callback, options);
	obs.observe(obTarget);

	function callback(entries, observer) {
		entries.forEach(entry => {

			if (entry.isIntersecting) {
				// console.log("topin");
				chgTarget.classList.add('show');
			} else {
				chgTarget.classList.remove('show');
				// console.log("topout");
			}
		})
	}
}


function obs2() {

	const obTarget = document.querySelector('.footerLinkArea');
	const chgTarget = document.querySelector('.contactLink');

	const options = {
		root: null,
		rootMargin: '0px',
		threshold: 0
	}

	const obs = new IntersectionObserver(callback, options);

	obs.observe(obTarget);

	function callback(entries, observer) {
		entries.forEach(entry => {

			if (entry.isIntersecting) {
				chgTarget.classList.remove('show');
			} else {

			}
		})
	}
}


obs1();
obs2();

